import { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { Button, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { LinkButtonProps } from './LinkButton.types';
import { ConfigProvider } from 'antd';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import styles from './LinkButton.module.scss';
import ArrowRight from '@/public/assets/arrow-right.svg';

const { Paragraph } = Typography;

const LinkButton = memo((props: LinkButtonProps) => {
  const { title, onClickEvent, hideIcon, isSubmitBtn = false, disabled = false } = props;

  const targetUrl = props?.targetUrl?.split('?')[0];

  const params = useMemo(() => {
    let paramsStr = props?.targetUrl?.split('?')[1];
    let paramsObj: any = {};
    paramsStr?.split('&').forEach(item => {
      let key = item.split('=')[0];
      let value = item.split('=')[1];
      paramsObj[key] = value;
    });
    return paramsObj;
  }, []);

  return (
    <>
      {props?.targetUrl && (
        <Link
          href={{ pathname: targetUrl, query: params }}
          style={{ display: 'block', height: 'auto' }}
        >
          <ConfigProvider
            theme={{
              components: {
                Button: {
                  fontWeight: 700,
                  contentFontSize: 16,
                  defaultColor: '#E87722',
                  defaultBorderColor: '#E87722',
                  defaultBg: '#ffffff',
                  paddingBlock: 10
                }
              }
            }}
          >
            <Button
              disabled={disabled}
              htmlType={isSubmitBtn ? 'submit' : 'button'}
              className={classNames(styles.link_button, {
                [styles.submit_button]: isSubmitBtn
              })}
            >
              {!hideIcon && (
                <Icon
                  component={ArrowRight}
                  style={{ fontSize: 24 }}
                  className={styles.link_button_title}
                />
              )}
              <span className={styles.link_button_title}>{title}</span>
            </Button>
          </ConfigProvider>
        </Link>
      )}
      {!props?.targetUrl && (
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontWeight: 700,
                contentFontSize: 16,
                defaultColor: '#E87722',
                defaultBorderColor: '#E87722',
                defaultBg: '#ffffff',
                paddingBlock: 10
              }
            }
          }}
        >
          <Button
            disabled={disabled}
            htmlType={isSubmitBtn ? 'submit' : 'button'}
            className={classNames(styles.link_button, {
              [styles.submit_button]: isSubmitBtn
            })}
          >
            {!hideIcon && (
              <Icon
                component={ArrowRight}
                style={{ fontSize: 24 }}
                className={styles.link_button_title}
              />
            )}
            <span className={styles.link_button_title}>{title}</span>
          </Button>
        </ConfigProvider>
      )}
    </>
  );
});
export default LinkButton;
